/**
 * 中文
 */
const lang = {
  home: "首页",
  fabujinglan: "发布精览",
  sections: "导览",
  magazine: "期刊",
  video: "课堂",
  about: "关于",
  exclusive: "新闻发布",
  review: "好文荐读",
  brief: "图说·数说",
  china: "读懂中国",
  people: "人物故事",
  culture: "中华之美",
  travel: "五洲有约",
  all: "全部",
  more: "查看更多",
  more2: "显示更多",
  more3: "查看全部",
  noMore: "已加载全部数据",
  latest: "新刊速递",
  trending: "热点文章排行榜",
  numbers: "数说发布",
  pictures: "图说发布",
  contents: "推荐文章",
  issues: "往期回顾",
  aboutUs: "《中国新闻发布》简介",
  journalists: "《中国新闻发布》记者",
  contact: "联系我们",
  email: "投稿信箱",
  email2: "邮箱",
  message: "读者留言",
  message2: "留言",
  subscribe: "订阅",
  subscribe2: "马上订阅",
  copyright: "中国新闻发布官网版权所有，未经授权禁止使用",
  search: "搜索",
  searchTheSite: "请输入要搜索的内容",
  searchResults: "搜索结果",
  keywordSearch: "搜索关键词",
  theQuarterly: "理论版",
  results: "共条",
  objectiveAndFairInterpretation: "解疑释惑  客观公正",
  editorialCenter: "采编中心 （010）58891088",
  readerService: "读者服务 （010）58891006",
  businessPromotion: "商务推广 （010）58591007",
  name: "姓名",
  company: "单位",
  telephone: "电话",
  address: "地址",
  attach: "附件",
  format: "支持格式：Word、PDF、zip，文件大小不超过20M",
  author: "作者：",
  source: "来源：",
  release: "发布时间：",
  presenter: "主讲人",
  course: "“只争”精品课",
  ted: "TED",
  documentary: "纪录片",
  live: "直播",
  verificationCode: "验证码",
  submit: "提交",
  pleaseName: "请输入姓名",
  pleaseTelephone: "请输入手机号",
  pleaseEmail: "请输入电子邮箱",
  pleaseCompany: "请输入单位",
  pleaseAddress: "请输入地址",
  pleaseCode: "请输入验证码",
  pleaseAttachment: "请上传附件",
  pleaseMessage: "请输入留言",
  showLess: "收起",
  //
  home: "首页",
  aboutWe: "关于我们",
  governance: "治理",
  world: "世界大会",
  Board: "执行委员会",
  news: "新闻",
  events: "重要事件",
  members: "成员",
};
export default lang;
